export default __webpack_public_path__ + "static/media/network_motherboard_power.c1c353a7.gif";